export default __webpack_public_path__ + "static/media/org_fax.05c76904.svg";